import { render, staticRenderFns } from "./wpsIframe.vue?vue&type=template&id=6956f314&"
import script from "./wpsIframe.vue?vue&type=script&lang=js&"
export * from "./wpsIframe.vue?vue&type=script&lang=js&"
import style0 from "./wpsIframe.vue?vue&type=style&index=0&id=6956f314&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports